export function playerIdNameParser(str) {
    const [name, playerIdString] = str.split(':');
    return { id: Number(playerIdString), name };
}
export function optionalPlayerIdNameParser(str) {
    if (!str) {
        return;
    }
    return playerIdNameParser(str);
}
